import { useDispatch } from 'react-redux';
import { setIsSaveViewModalOpen, useIsSaveViewModalOpen } from 'reducers/viewsSlice';

import { Info } from 'assets/assetsV1/iconComponents/Info';

import { ConfirmationModal } from 'uiToolkitV1/ConfirmationModal';

const TitleComponent = () => (
  <>
    <Info boxSize="32px" />
    <span style={{ marginLeft: '4px' }}>Confirmation</span>
  </>
);

export const DeleteViewModal = ({ isLoading, deleteView }) => {
  const isSaveViewModalOpen = useIsSaveViewModalOpen();
  const dispatch = useDispatch();

  return (
    <ConfirmationModal
      isCentered
      isOpen={isSaveViewModalOpen}
      onClose={() => dispatch(setIsSaveViewModalOpen(false))}
      title={<TitleComponent />}
      body="Deleting the saved view will permanently remove it from the system and cannot be undone. Are you sure you want to delete the saved view?"
      cancelText="Cancel"
      onCancel={() => dispatch(setIsSaveViewModalOpen(false))}
      continueText="Delete"
      onContinue={deleteView}
      disabled={isLoading}
      primaryActionButtonColor="red"
    />
  );
};
